'use client';

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../contexts/ApiContext';
import { queryKeys } from '../../../lib/queryClient';
import type { CatalogItem, CatalogResponse } from '../../../services/generated/Api';

export type { CatalogItem, CatalogResponse };

export function useCatalog() {
  const api = useApiClient();
  return useQuery({
    queryKey: queryKeys.achievementsCatalog,
    queryFn: () => api.api.achievementsControllerGetCatalog(),
    staleTime: 60 * 60 * 1000,
  });
}
